import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/external-data-sets']['GET'];
type Input = ThisApi['query'];

const getDataReferences = async ({ page, perPage, search }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/external-data-sets');
  const data = await formsBackendClient.get(path, {
    params: {
      page,
      perPage,
      search,
    },
  });
  return data.data;
};

export default getDataReferences;